<div class="-oneX-container">
    <div class="-oneX-container">
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-heading--h1">Medical Provider Claim View Portal </div>
        </div>
        <br>
        <div class="-oneX-row">
            <app-search></app-search>
        </div>
    </div>
</div>